import React from "react";

const AboutPage: React.FC = () => {
  return (
    <main className="flex-1 px-6 py-10 max-w-7xl mx-auto w-full">
      <h1 className="text-4xl font-bold mb-8 text-white">About BoredGames</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        <p className="text-white text-lg">
          Welcome to BoredGames! 
        </p>
        <p className="text-white text-lg">
          The goal of this site is to provide users with games, social features, and a fun community. I am currently working to implement theses as soon as possible.
        </p>
        <p> </p>
        <h1 className="text-4xl font-bold mb-8 text-white">Contact us</h1>
        <p className="text-white text-lg">
          Join our community on Discord. Discord Link: https://discord.gg/Abf8dyUDN3
        </p>
      </div>
    </main>
  );
};

export default AboutPage;
